import { render } from "./PosPreviewReceipt.vue?vue&type=template&id=5dad7e48&scoped=true&ts=true"
import script from "./PosPreviewReceipt.vue?vue&type=script&lang=ts"
export * from "./PosPreviewReceipt.vue?vue&type=script&lang=ts"

import "./PosPreviewReceipt.vue?vue&type=style&index=0&id=5dad7e48&scoped=true&lang=css"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dad7e48"]])

export default __exports__